import { gql } from '@apollo/client';

export const GET_FEATURE_FLAGS = gql`
    query GetFeatureFlags {
        getFeatureFlags {
            id
            name
            enabled
            targetUsers
            allowedPlanTypes
            customUserIds
            description
            voteable
            value
            createdAt
            updatedAt
        }
    }
`;

export const GET_FEATURE_FLAG = gql`
    query GetFeatureFlag($name: String!) {
        getFeatureFlag(name: $name) {
            id
            name
            enabled
            targetUsers
            allowedPlanTypes
            customUserIds
            description
            voteable
            value
            createdAt
            updatedAt
        }
    }
`;

export const CREATE_FEATURE_FLAG = gql`
    mutation CreateFeatureFlag($input: FeatureFlagInput!) {
        createFeatureFlag(input: $input) {
            id
            name
            enabled
            targetUsers
            allowedPlanTypes
            customUserIds
            description
            voteable
            createdAt
            updatedAt
        }
    }
`;

export const UPDATE_FEATURE_FLAG = gql`
    mutation UpdateFeatureFlag($name: String!, $input: UpdateFeatureFlagInput!) {
        updateFeatureFlag(name: $name, input: $input) {
            id
            name
            enabled
            targetUsers
            allowedPlanTypes
            customUserIds
            description
            voteable
            value
            updatedAt
        }
    }
`;

export const DELETE_FEATURE_FLAG = gql`
    mutation DeleteFeatureFlag($name: String!) {
        deleteFeatureFlag(name: $name)
    }
`;

export const TOGGLE_FEATURE_FLAG = gql`
    mutation ToggleFeatureFlag($name: String!) {
        toggleFeatureFlag(name: $name) {
            id
            name
            enabled
            targetUsers
            allowedPlanTypes
            voteable
        }
    }
`;
